var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNotSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#EEEDF2",
    stroke: "#7161BA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5913,
    cy: 14.3178,
    r: 6.95455,
    fill: "#7161BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1577 32.1254C26.0904 34.5516 22.2142 36.0001 17.9996 36.0001C13.4694 36.0001 9.32997 34.3265 6.16602 31.5638C7.56563 26.5707 12.1505 22.9092 17.5905 22.9092C23.2326 22.9092 27.9548 26.8477 29.1577 32.1254Z",
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotSign);
export default __webpack_public_path__ + "static/media/userNotSign.6b4385ae1c16ec135bb1454bf76967e4.svg";
export { ForwardRef as ReactComponent };